import {lazy} from 'react';
import GenericFallbackSuspense from '../../ui/GenericFallback/GenericFallbackSuspense';

const ResidentIDWrapper = lazy(() => (
  import('./ResidentIDWrapper'/* webpackChunkName: 'ResidentIDWrapper' */)
));

export default function ResidentIDLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <ResidentIDWrapper {...props} />
    </GenericFallbackSuspense>
  );
}
